import styled from 'styled-components'

const TrackDetail = styled.div`
  flex: 1;
  
  margin-bottom: 15px;
  
  border-radius: 10px;
  box-shadow: 0 2px 10px 0 #00000029;
  > p {
    color: #33333a;
    font-size: 14px;
  }
  .upload {
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (max-width: 767px) {
    padding: 6px;
  }
`;


const TrackBox = styled.div`
  padding: 0;

  .colorfull {
    color: #717171;
    font-family: "latobold";
    margin-bottom: 0;
    padding-right: 10px;
  }
  .flexWrapper {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0;
    min-height: 20px;
    color: #717171;
    font-size: 15px;
    span {
      display: block;
    }
  }
  button {
    background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
    padding: 4px 10px;
    color: #fff !important;
    border-radius: 5px;
    cursor: pointer;    
    border: none;
  }
  > div {
    flex: 1;
    display: flex;
    > div {
      flex: 1;
    }
  }
  @media (max-width: 767px) {
    padding: 20px;
    :nth-child(1) {
      grid-template-columns: 1fr;
    }
    > div {
      grid-template-columns: 1fr;
      grid-row-gap: 10px;
      display: grid;
    }
    p {
      font-size: 16px;
      min-height: 15px;
      word-break: break-word;
    }
    .colorfull {
      font-size: 16px;
    }
  }
`;
const NoRecordFound = styled.div`
    text-align: center;
    background: white;
`
const TrackBoxAction = styled.div`
  color: #717171;
  margin-top: 8px;
   .radioOption {
    flex: 1;
    border-radius: 8px;
    padding: 6px 0px;
  }
  .submitAction {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 10px 15px;
    flex: 1;
  }
`;
const Auth = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 15px 0;
  font-size: 15px;
  font-family: "latomedium";
  border-top: solid 1px #c5c5c5;
  margin-top: 15px;
  text-decoration: underline;
  span {
    transform: rotate(87deg);
  }
`;
const DescriptionBox = styled.div`
  display: grid;
  grid-template-columns:1fr;
  margin-top: 24px;
  padding: 0 36px 20px;
  @media (max-width: 767px) {
    padding: 0;
  }
  .image-wrapper {
    padding: 10px 25px;
    border: solid 1px #87cdf1;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: auto;
      max-height: 169px;
      max-width: 100%;
    }
  }
`;
const BoxWrapperNew = styled.div`
  width: 100% !important;
  .colorfull {
    font-family: "latobold";
    margin-bottom: 0;
  }
  > div {
    flex: 1;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-row-gap: 10px;
    display: grid;

    p {
      font-size: 16px;
      min-height: 15px;
    }
    .colorfull {
      font-size: 16px;
    }
  }
`;
const HeaderSection = styled.div`
  p {
    color: #80af2e;
    font-size: 17px;
    font-family: "latobold";
    line-height:1;
  }
`;



const Heading = styled.div`
  position: relative;
  padding: 22px 0 15px 98px;
   img.right-arrow {
    position: absolute;
    left: 0;
    top: 15px;
  }
  h2 {
    font-size: 24px;
    color: #717171;
    font-family: "latobold";
    text-align: left;
    line-height: 27px;
   
  }
`;

const RaisedClaimChatBox = styled.div`
  max-width: 400px;
  width: 100%;
  overflow: auto;
  position: absolute;
  top: 50px;
  border-radius: 10px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #bebebe;
  background-color: #fff;
  z-index:1;
  @media (max-width: 465px){
    max-width: 290px;
  }
`;

const Chatbox = styled.div`
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 0px 0px 0px 2px;
  flex: 0.8;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
  border: solid 1px #627493;
  background-color: #fff;
  border-radius: 15px 15px 0 15px;
  padding: 17px 22px;
  position: relative;
`;

const ChatHeader = styled.div`
  background-color: #0a5587;
  height: 63px;
  color: #fff;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  grid-gap: 20px;
  padding: 0 40px 0 10px;
  position: relative;
  
  h6 {
    font-size: 22px;
    small {
      font-size: 13px;
      margin-left: 8px;
    }
  }
  .close-icon {
    position: absolute;
    right: 15px;
    cursor: pointer;
  }
`;
const ChatText = styled.div`
  p {
    font-size: 16px;
    color: #000;
    line-height: 18px;
  }
`
const TimeStamp = styled.div`
  position: absolute;
  font-size: 10px;
  right: 24px;
`;
const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin: 0 9px;
  max-width: 30px;
  text-align: center;
  p {
    margin: 0;
    font-size: 10px;
  }
`;
const ChatboxBody = styled.div`
  .seller {
    justify-content: flex-end;
    ${Chatbox} {
      border: solid 1px #87cdf1;
    }
    ${IconWrapper} {
      color: #87cdf1;
    }
  }
  .buyer {
    justify-content: flex-end;
    ${Chatbox} {
      border: solid 1px #0a5587;
    }
    ${IconWrapper} {
      color: #0a5587;
    }
  }
  .admin {
    ${Chatbox} {
      border-radius: 15px 15px 15px 0;
    }
  }
  > div {
    display: flex;
    padding: 0;
    margin: 20px 0;
  }
`;

const TextAreaWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 25px;
  border-top: solid 1px #c5c5c5;
  padding: 12px 15px;
  align-items: flex-end;
  justify-content: space-between;
  textarea {
    border: none;
  }
`;
const CenterBox = styled.div`
  > div {
    display: grid;
    grid-template-columns: 0.8fr 1fr;
    position: relative;
  }
`;
const ChatBtn = styled.div`
  border-radius: 13px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  color: #717171;
  font-size: 14px;
  cursor: pointer;
  height: 42px;
  width: 196px;
  justify-content: center;
  svg {
    margin-right: 10px;
    margin-top: 4px;
  }
`;
export {
  Heading,
  RaisedClaimChatBox,
  ChatHeader,
  TrackDetail,
  TrackBox,
  NoRecordFound,
  TrackBoxAction,
  Auth,
  BoxWrapperNew,
  DescriptionBox,
  HeaderSection,
  Chatbox,
  ChatText,
  TimeStamp,
  ChatboxBody,
  IconWrapper,
  TextAreaWrapper,
  CenterBox,
  ChatBtn,
};